// 中文繁體

export const main = {
  KubuqiOfficialWebsite: '庫布其奬',
  // 導航信息
  homePage: '首頁',
  backgroundOfTheCompetition: '大賽背景',
  latestNews: '最新資訊',
  previousCompetition: '第一屆比賽花絮',
  firstCompetition: '第一屆庫布其大賽',
  previousCompetitionTwo: '第二屆比賽花絮',
  firstCompetitionTwo: '第二屆庫布其大賽',
  secondCompetition: '網上公眾投票',
  secondBackText:
    '第二屆庫布其奬 - 「談談可持續」中學生短片比賽反應踴躍，收到超過100條參賽短片。評審團已選出15條入圍短片供公眾在網上投票，投票結果佔總成績的20%，每一票都至關重要！',
  active: '「談談可持續」短片投票',
  pastGames: '過往比賽',
  topUniversity: '大學組獲奬名單',
  commonProblem: '常見問題',
  aboutUs: '關於我們',
  findUs: '聯絡我們',
  loginAndRegistration1: '登入/註冊',
  loginAndRegistration: '登入',
  // 底部信息
  filingNumber: '備案號碼',
  YiliPublicWelfareFoundation: '億利公益基金會',
  contactAddress: '聯繫地址',
  contactAddressDetaile: '香港灣仔港灣道18號中環廣場60樓6005室',
  notice_info:
    '請注意：主辦機構對此次比賽的規則和結果保留最終決定權，不作另行通知',

  contactUs: '聯繫我們',
  phone: '電話',
  socialMedia: '社交媒體',

  // 首頁
  competitionSchedule: '大賽時間表',
  seeMore: '查看更多',
  previousCompetitions: '第一届庫布其獎得獎名單',
  introductionToTheOrganizer: '主辦機構',
  introductionToTheOrganizerDetail:
    '億利公益基金是由億利國際投資有限公司發起的公益慈善組織，專注於環境保護事業。 該基金會致力於推動國際和國內生態治理和環保領域的新科技和新模式發展，特別是在“一帶一路”國家的環境治理和可持續發展方面。',
  workName: '作品名稱',
  and: '及',
  WinningTeam: '得獎隊伍',
  Awarded: '獲得獎項',
  CompetitionName: '比賽名稱',
  OfficialEventManagementPartner: '大會活動管理合作夥伴',
  OfficialAdvisoryServicePartner: '大會諮詢服務合作夥伴',
  OfficialSocialImpactPartner: '大會社會影響力合作夥伴',
  OfficialMentorshipPartner: '大會專家導師夥伴',
  contextDetaile: '比賽詳情',
  CompetitionIntroduction: '大賽介紹',
  PleaseEnterContent: '請輸入內容',
  submitComments: '提交評論',
  commentHistory: '評論記錄',
  noComments: '暫無評論',

  // 首頁-獎項
  awards: '獎項',
  associateHongKongGroup: '大學組',
  middleSchoolGroup: '中學組',
  middleSchoolGroup1: '中學組',
  universityInternationalGroup: '大學組',
  universityInternationalGroup1: '大學國際組',
  championTeam1: '冠軍一隊',
  championTeam11: '冠軍一隊',
  runnerUpTeam1: '亞軍一隊',
  runnerUpTeam11: '亞軍一隊',
  thirdPlaceTeam1: '季軍一隊',
  thirdPlaceTeam11: '季軍一隊',
  excellentAwardTeam7: '優秀獎十二隊',
  excellentAwardTeam71: '優秀獎七隊',
  DepartureFormHongKongSAR: '從香港特別行政區出發',

  bonus: '獎金',
  certificate: '獎狀',
  andDesertFieldVisits: '獎狀及沙漠實地考察',
  andDesertFieldVisitsHKcollege: '獎狀',
  excellentAwardNTeam: '優秀獎N隊',
  mostEnthusiasticParticipation: '優秀獎十二隊',
  mostEnthusiasticParticipation1: '最踴躍參與學校獎一所（以參賽隊伍數目計算）',
  fieldVisit: '*所有得獎計劃書有機會應用於庫布其沙漠及其他國家沙漠治理項目',
  signUpNow: '立即報名',
  RegistrationDetermined: '報名截止日期',
  SubmissionDetermined: '作品提交截止日期',
  sliderTitle: '掃碼體驗',
  sliderSubtitle: '庫布其獎AR場景',
  RightOfInterpretation:
    '如任何組別最終提交參賽作品不足50份，主辦單位有權修改該組別賽製或取消該組別比賽。',
  mostActive: '最踴躍參與學校獎',
  mostActiveSchool: '迦密柏雨中學',

  //
  supportingEnterprises: '支持單位',
  // 庫布其大賽報名
  registrationForTheKubuqiCompetition: '庫布其大賽報名',
  teamInformation: '團隊資訊',
  TEAMNAME: '團隊名稱',
  fullName: '姓名',
  position: '職位',
  dateOfBirth: '出生日期',
  schoolName: '學校名稱',
  studentID: '學生編號',
  Email: '電子郵箱',
  studentIDCard: '學生證',
  selectGroup: '請選擇參賽組',
  confirmRegistration: '確認報名',
  registrationSuccessful: '報名成功！',
  registrationSuccessfulTips: '你會在稍後收到比賽報名成功確認電郵',
  pleaseContact: '如有任何査詢，請聯絡',
  viewAuditProgress: '查看稽核進度',
  noData: '暫無數據',

  // 最新資訊
  newsInformation: '最新消息、社交媒體貼文',
  pressRelease: '大賽新聞稿、有關大賽報導',
  contestAtlas: '大賽圖集',
  currentPosition: '當前位置',
  informationDetails: '資訊詳情',
  issueDetails: '問題詳情',
  Comment: '發表評論',
  warnInfo6: '請輸入要評論的內容！',
  warnInfo7: '評論成功',
  videoTitle1:
    '第二屆庫布其獎：大學宣講會 香港教育大學：『全球暖化、氣候變遷』環境、社會及管治(ESG)策略',
  videoTitle2:
    '第二屆庫布其獎：大學簡介會 —— 香港恒生大學：『永續金融：商業領域的綠色發展』探索綠色經濟全新職業道路',

  // 個人中心
  personalCenter: '個人中心',
  accountInformation: '賬號信息',
  myRegistration: '我的報名',
  // contactUs : '聯繫我們',
  logOut: '退出登錄',

  //個人中心-基本信息
  basicInformation: '基本資料',
  avatar: '頭像',
  teamInformation: '團隊資料',
  addMembers: '添加成員',
  save: '保存',
  teamName: '團隊名稱',
  delete: '刪除',
  reset: '重置',
  edit: '編輯',
  modify: '修改',
  uploadCampusCard: '上傳學生證',
  front: '正面',
  opposite: '反面',

  // 個人中心-我的報名
  registeredContest: '已報名大賽',
  theKubuqiCompetition: '庫布其大賽',
  matchProgress: '比賽進度',
  registrationStatus: '報名狀態',
  workStatus: '作品狀態',
  pendingApproval: '待審批',
  passed: '已通過',
  fail: '未通過',
  WorkSubmissionTime: '作品提交時間',
  viewDetails: '查看詳情',
  currentState: '當前狀態',
  goToModifyInformation: '前往修改資訊',
  return: '返回',
  clickToSubmit: '點擊提交',
  modifyInformation: '請前往修改資訊！',
  comingToAnEnd: '即將截至',
  copyEmailAddress: '複製電郵地址',
  registrationTeam: '報名隊伍',
  competitionBrowsing: '大賽瀏覽',
  officialEmail: '大賽官方郵箱',
  workSubmit: '作品提交',
  tips: '提示：請上傳作品附件，附件類型：視頻、PDF、PPT',
  warnInfo: '提示：請上傳作品附件（影片、PDF、PPT），文件大小不超過2GB。！',
  warnInfo1: '上傳失敗！',
  checkEntryStatementInfo: '請先勾選作品聲明。',

  // 個人中心-作品狀態
  notFiled: '未提交',
  submitted: '已提交',
  underReview: '評審中',
  beShortlistedSuccessfully: '入圍成功',
  shortlistingFailure: '入圍失敗',
  clickToUpload: '點擊上傳',
  uploading: '正在上傳',
  // cancellation: '取消',
  submitWorks: '提交作品',
  IAmAgree: '我已閱讀、並同意',
  EntryStatement: '參賽作品聲明',
  IntellectualProperty: '一、知識產權',
  IntellectualPropertyInfo:
    '參賽者須確保其參賽作品必須為原創及不會侵犯第三者的權利，包括知識產權、保密權或私隱權。如有侵權行為，參賽者須承擔一切法律責任。',
  KnowledgeSharing: '二、知識共享',
  KnowledgeSharingInfo:
    "參賽者理解並同意，參賽作品的知識產權將用於教育、科學普及和生態環保等非營利性目的。億利公益基金會和TREELION Foundation創益基金會（以下簡稱'主辦方'）主辦方承諾在非商業用途下使用這些作品，以促進沙漠可持續發展和生態保護的理念。",
  LegalResponsibility: '三、法律責任',
  LegalResponsibilityInfo:
    '主辦方將盡最大努力保護參賽作品的知識產權，但不對可能發生的侵權行為承擔法律責任。如有任何爭議，將依據相關法律法規解決。',
  CopyrightOwnership: '四、版權歸屬',
  CopyrightOwnershipInfo: '所有參賽作品一經提交，版權全部歸主辦方所有。',
  CopyrightUsage: '五、版權使用',
  CopyrightUsageInfo1:
    '1. IP使用權： 參賽者特此同意，主辦方擁有使用參賽作品的知識產權（IP）的權利，包括但不限於覆制、傳播、轉發、展示、出版、修改和以其他方式利用作品。主辦方僅可在非商業下使用參賽作品，包括但不限於宣傳、推廣、廣告和任何與大賽相關的活動。',
  CopyrightUsageInfo2:
    '2. 作者署名權： 除非參賽者另行書面要求匿名，主辦方將在任何使用參賽作品的場合下盡力署名作者。在任何情況下，署名將僅包括參賽者的名字，不會包括其他個人信息。主辦方將盡力保護參賽者的隱私。',
  CopyrightUsageInfo3:
    '3. 宣傳與推廣：參賽者同意主辦機構使用其姓名、相片及簡報等作宣傳及推廣之用。',
  CopyrightUsageInfo4:
    '4. 放棄權益：參賽者明確放棄對參賽作品的任何形式的經濟權益或其他權益，除非另有書面協議。',
  AttendanceOnJudgingDay: '六、出席比賽評審日',
  AttendanceOnJudgingDayInfo:
    '關於香港大學組，所有提交了計劃書並成功進入決賽的參賽者，必須親身出席決賽評審日 (香港組現場評審)。',
  PrivacyStatement: '七、私隱條例',
  PrivacyStatementInfo:
    '參賽者明白及同意主辦方收集個人資料，包括參賽者姓名、電郵地址及聯絡電話，僅用於本比賽核對參賽者身份和聯絡得獎者用途。主辦方會於本比賽結果公布後三個月內銷毀參賽者提供的個人資料（於本比賽社交媒體及網站公布的資料除外），主辦方並不會將個人資料轉移予其他第三者（按法律或法例規定除外）。',
  AgreementEffectiveness: '八、協議生效',
  AgreementEffectivenessInfo:
    '參賽者提交參賽作品即表示同意本聲明的所有條款和條件，並受其約束。',
  lastNoticeInfo:
    '* 請注意： 主辦機構對此次比賽的規則和結果保留最終決定權，不作另行通知。若您對以上聲明的任何部分有疑問或需要進行特殊協商，請與主辦方聯系，以進一步明確您的權益和期望。',

  // 登錄頁面
  loginAccount: '登入帳號',
  mailbox: '郵箱',
  pleaseEnterTheRegistrationEmail: '請輸入註冊郵箱',
  password: '密碼',
  pleaseEnterYourLoginPassword: '請輸入登入密碼',
  code: '驗證碼',
  pleaseEnterTheVerificationCode: '請輸入驗證碼',
  sendVerificationCodeToEmail: '發送驗證碼到郵箱',
  codeTime: '秒後重試',
  SendVerificationCode: '發送驗證碼',
  TheVerificationCodeHasBeenSent: '驗證碼已發送到郵箱，請注意查收',
  logInNow: '立即登錄',
  noAccount: '沒有帳號？ 馬上',
  register: '註冊',
  warnInfo2: '請輸入賬號和密碼！',
  warnInfo21: '登錄成功！',

  // 註冊頁面
  accountRegistration: '帳戶註冊',
  confirmPassword: '確認密碼',
  pleaseReenterTheLoginPassword: '請再次輸入登入密碼',
  fullName: '姓名',
  PleaseEnterTheTeamName: '請輸入團隊名稱',
  // dateOfBirth : "出生日期",
  // schoolName : "學校名稱",
  // studentID : "學生編號",
  registerNow: '立即註冊',
  backLoginText: '返回登錄',
  existingAccount: '已有帳號？ 馬上',
  login: '登入',
  warnInfo3: '確認密碼與設置密碼不一致!',
  warnInfo8: '請輸入正確格式郵箱',
  warnInfo9: '驗證碼只有六位數哦',
  warnInfo10: '秒後重新發送',
  warnInfo11: '最少兩名成員參賽',
  warnInfo16: '請上傳學生證',
  warnInfo17: '隊員信息請填寫完整哦',
  warnInfo18: '最多只能有四名成員哦',
  warnInfo19: '隊員信息請輸入完整喲',
  warnInfo20: '最多只有四位成員喲',

  // 個人中心-賬號信息
  accountEmail: '帳號郵箱',
  captain: '隊長',
  member: '隊員',
  pleaseEnterTheCaptainName: '請輸入隊長姓名',
  pleaseEnterAMember: '請輸入隊員',
  PleaseEnterTheDateOfBirth: '請輸入出生日期',
  PleaseEnterSelectBirthDay: '請選擇出生日期',
  pleaseEnterTheSchoolName: '請輸入學校名稱',
  pleaseEnterTheStudentId: '請輸入學生編號',
  pleaseEnterEmail: '請輸入電子郵箱',
  pleaseEnterEmailInfo: '請輸入郵箱',
  pleaseEnterYourName: '請輸入姓名',
  pleaseUploadYourCampusCard: '請上傳學生證',
  warnInfo4: '報名已截止！',
  warnInfo5: '退出成功！',
  warnInfo12: '修改成功',
  warnInfo13: '修改失敗',
  warnInfo14: '請輸入正確的隊名',
  warnInfo15: '請上傳圖片',

  // 個人信息-修改個人信息-彈窗
  changePassword: '修改密碼',
  enterOldPassword: '輸入舊密碼',
  pleaseEnterYourOldPassword: '請輸入舊密碼',
  enterANewPassword: '輸入新密碼',
  pleaseEnterANewPassword: '請輸入新密碼',
  confirmPasswordAgain: '再次輸入密碼',
  pleaseConfirmTheNewPassword: '請確認新密碼',
  passwordInfo: '*密碼長度至少16比特，且包含大、小寫字母及數位',
  cancellation: '取消',
  confirmModification: '確認修改',
  passwordWarnText: '密碼長度至少6位',

  // 關於我們
  yiliPublicWelfareFoundation: '億利公益基金會',
  yiliPublicWelfareFoundationInfo:
    '億利公益基金會億利公益基金是由億利國際投資有限公司發起的公益慈善組織，專注於環境保護事業。 該基金會致力於推動國際和國內生態治理和環保領域的新科技和新模式發展，特別是在“一帶一路”國家的環境治理和可持續發展方面。',
  DesertificationEnvironmentDiffusion: '荒漠化環境擴散',
  PromoteEcologicalGovernanceEducation: '推動生態治理教育',
  InheritingGreenEnvironmental: '透過活動傳承綠色環保',
  passActiveInfoOne: '第八屆庫布其國際沙漠論壇',
  passActiveInfoTwo: '香港綠色金融分論壇2021',
  passActiveInfoThree:
    '億利公益基金會亦於2021年9月28日與香港地球之友聯合舉辦第八屆庫布其國際沙漠論壇的香港綠色金融分論壇。以「碳達峰．碳中和— 共建人與自然生命共同體」為主題，邀請80多位元綠色金融專家和專業人士。其中不乏香港及中國內地綠色金融行業的頂尖級專家學者及業界翹楚，包括香港綠色金融協會主席馬駿教授、聯合國副秘書長兼聯合國環境署執行主任埃裏克·索爾海姆先生、現任生態環境部宣傳教育中心主任賈峰等。大家共聚一堂探討香港作為國際金融中心，如何引導資本建設低碳經濟以達至碳中和，提出不少關於香港綠色金融發展的寶貴意見和建議。 ',
  passActiveInfoFour:
    '億利公益基金會相信綠色金融是緩解全球暖化的關鍵工具。這能令香港能夠抓緊大灣區的機遇，到2050 年實現碳中和，成為亞太地區的綠色金融中心。',

  treelionFoundation:
    '由億利國際投資有限公司孵化的Treelion Foundation於2019年在新加坡正式註冊成立，是全球最大的綠色生態基金之一。基金會計畫利用區塊鏈科技，構建可持續發展和低碳綠色數字經濟平臺。',
  contactInformation: '聯絡方式',
  eleEmail: '電郵',
  DesertForumTitle: '第八屆庫布其國際沙漠論壇',
  The8thKubuqiInternationalDesertForumin2021: '第八屆庫布其國際沙漠論壇',
  HongKongGreenFinanceSubForumTitle: '香港綠色金融分論壇2021',
  DesertForumInfo: `<p>億利公益基金會亦於2021年9月28日與香港地球之友聯合舉辦第八屆庫布其國際沙漠論壇的香港綠色金融分論壇。以「碳達峰．碳中和—共建人與自然生命共同體」為主題，邀請80多位元綠色金融專家和專業人士。其中不乏香港及中國內地綠色金融行業的頂尖級專家學者及業界翹楚，包括香港綠色金融協會主席馬駿教授、聯合國副秘書長兼聯合國環境署執行主任埃裏克·索爾海姆先生、現任生態環境部宣傳教育中心主任賈峰等。大家共聚一堂探討香港作為國際金融中心，如何引導資本建設低碳經濟以達至碳中和，提出不少關於香港綠色金融發展的寶貴意見和建議。 </p><p>億利公益基金會相信綠色金融是緩解全球暖化的關鍵工具。這能令香港能夠抓緊大灣區的機遇，到2050 年實現碳中和，成為亞太地區的綠色金融中心。 </p>`,
  briefItemInfo1:
    '以荒漠化防控和生態保護為切入點，重點聚焦解決土地、大氣、土、水和生物污染治理問題，推動全球生態文明建設',
  briefItemInfo2:
    '重新定義綠色資產、打造生態、金融與互聯網相結合的可持續發展的綠色商業模式，致力創建全球最大的綠色數位資產生態系統',
  briefItemInfo3:
    '利用區塊鏈的分佈式、不可篡改和協同共識特性，記錄全球環境及生物多樣性數據，構建全球生態大數據平臺',
  briefItemInfo4:
    '在全球範圍內推動國際、地區、國家和地方等多層次的廣泛的綠色合作、實現生態文明共建、共亯、共贏的發展機會',
  CochairsoftheGlobalSteeringCommittee: '全球指導委員會聯席主席',
  GlobalEnvironmentalandDevelopmentLeaders: '全球環境與發展領袖',
  FormerDeputySecretaryGeneraloftheUnitedNations: '前聯合國副秘書長',
  FormerExecutiveDirectorofUNEP: '環境規劃署前執行主任',
  FormerNorwayMinisterofEnvironmentandInternationalDevelopment:
    '前挪威環境和國際發展部部長',
  FormerExecutiveDirectoroftheUnitedNationsEnvironmentProgramme:
    '前聯合國環境署執行主任',
  ChiefExecutiveOfficerandDirectors: '首席執行官及董事',
  ChairmanoftheBoardofDirectorsofFriends: '地球之友(香港)董事會主席',
  MemberoftheInvestmentCommitteeInfo1: '香港特區政府獎學基金投資委員會委員',
  MemberoftheInvestmentCommitteeInfo2:
    '香港特區政府自資專上教育基金投資委員會委員',
  InvestmentCommitteeoftheHKSARGovernmentScholarshipFund:
    '香港特別行政區政府獎學基金投資委員會',
  MemberofSelffinancingPostsecondaryEducationFundInvestmentCommitteeoftheHKSARGovernment:
    '香港特別行政區政府自負盈虧專上教育基金投資委員會委員',
  MrErikSolheim: '埃裏克·索爾海姆先生',
  MrPlatoKTYip: '葉廣濤先生',

  // 歷屆比賽花絮
  previousShortFilms: '往屆比賽介紹短片',
  previousShortFilmsTips: '第一屆比賽視頻宣傳片',
  previousPhotos: '往屆比賽照片',
  previousVisits: '往屆比賽訪問',
  previousVisitsName1: '從想像中的荒漠到眼前的綠洲——香江學子的庫布其之行',

  // 大賽背景
  countdown: '庫布其大賽報名截止日倒計時',
  deadline: '比賽截至報名日期',
  dateOfPublication: '賽果公佈日期',
  year: '年',
  month: '月',
  sun: '日',
  day: '天',
  KBQbackgroundOfTheCompetition: '庫布其模式',
  KBQbackgroundOfTheCompetitionInfo: `<p>由於全球氣候環境變化，全球超過<span class="highlight">2.5億</span>人受到土地荒漠化的直接影響，約有<span
class="highlight">10億</span>人生存情況因此岌岌可危。全球約<span class="highlight">20億</span>人依賴於乾旱地區的生態系統，其中<span
class="highlight">90%</span>生活在發展中國家，「一帶一路」國家正是荒漠化嚴重的主要區域之一。
</p>
<p>
庫布其沙漠是<span class="highlight">中國第七大</span>的沙漠，位於內蒙古鄂爾多斯，總面積為<span
class="highlight">1.86萬</span>平方公里，是離北京最近的沙漠。庫布其沙漠在清朝時期早先是一片草原，但由於過度放牧等多種原因，在清末逐漸荒漠化，曾被稱為「死亡之海」。經過近<span
class="highlight">30年</span>的艱辛治沙，今天的庫布其沙漠已變回綠洲。已有三分之一的沙漠面積得到修復，土地重新蓬勃發展，生物種類達到了530種。恢復經濟活動使得<span
class="highlight">10多萬</span>牧民脫貧，<span class="highlight">30年</span>的治理創造了聯合國推崇的「庫布其模式」。
</p>`,
  KBQawards: `<p>本屆<span class="highlight">「庫布其獎」：國際沙漠可持續發展大賽</span>及<span class="highlight">「談談可持續」中學生短片比賽</span>旨在鼓勵香港乃至國際年輕人關注<span class="highlight">全球氣候環境議題</span>、思考<span class="highlight">全球和國家的沙漠治理及可持續發展</span>，並同時發掘國際優秀及有潛力的人才，為生態環保和新型可持續發展領域培養未來的行業領袖，不僅對國內，甚至對於「一帶一路」的環境治理模式提供積極貢獻。 </p>
</ br ><p>比賽讓大專及大學生開拓思路，提出創新且可行的沙漠可持續發展方案，以推動解決當前土地荒漠化問題，響應全球碳中和政策目標，並為生態環保和新型可持續發展領域培養未來的行業領袖。同時，讓中學生通過拍攝短片了解可持續發展對於生態脆弱地區的重要作用。 </p>`,
  target: '聯合國可持續發展目標',
  targetInterpretation:
    '庫布其大賽全力推動聯合國的17項可持續發展目標（SDGs），特別聚焦於目標4（教育）、目標13（氣候行動）以及目標17（合作實現目標）。此次大賽主題聚焦於沙漠可持續發展，並充分考慮現今以及未來兩個發展時間軸。學生參賽作品將有機會涵蓋更多的目標，藉此進一步促進這些目標的實現。',
  targetInterpretation1: `SDGs 建基於可持續發展的三大基石：經濟增長、環境保護及社會進步，期望在促進經濟發展的同時，亦能保護地球環境及減少不平等，讓世界變得更繁榮、健康、包容，與可持續。響應聯合國所訂立的目標，為建立可持續發展的社會群策群力。瞭解更多關於聯合國的17項可持續發展目標及詳細準則，可參閲<a href ="https://sdgs.un.org/ zh " target="_blank" rel =" noopener noreferrer ">SDG官網</a>。`,
  contestTheme: '大賽組別',
  topicIntroduction: '主題介紹',
  contestMode: '大賽模式',
  YouthSustainableDevelopmentEducation: '青少年可持續發展教育',
  YouthInfoOne: '確保香港學生獲得促進可持續發展和環境保護所需的知識和技能',
  YouthInfoTwo: '鼓勵跨學科批判性思維、問題解決和知識的實際應用',
  YouthInfoThree:
    '促進全球公民意識和對文化多樣性以及文化對可持續發展的貢獻的欣賞',
  YouthInfoFour: '培養未來環境保護和可持續發展的領導者',
  YouthInfofive:
    '促進全球公民意識和對文化多樣性以及文化對可持續發展的貢獻的認識',
  ClimateEducationTheme: '氣候教育主題',
  ImprovingEducation: '提高減緩氣候變化的教育、意識和能力',
  ImprovingEducationInfoOne: '提高人們對採取氣候行動重要性的認識',
  ImprovingEducationInfoTwo: '激發年輕一代對環保的興趣',
  PartnershipAchieveGoals: '實現目標的夥伴關係',
  PartnershipAchieveGoalsInfo:
    '通過尋求贊助和合作來支持庫布其獎倡議和防治荒漠化，調動資源，在可持續發展方面發揮更大影響',
  // 大賽主題
  topicIntroductionText:
    '為鼓勵香港以至國際年輕人關注全球氣候環境議題、思考全球和國家的沙漠治理及可持續發展，「談談可持續」中學生短片比賽讓香港中學生通過拍攝短片了解可持續發展對於生態脆弱地區的重要作用，提升公眾對全球氣候環境議題的關注，響應全球可持續發展目標。 ',
  topicIntroductionCollegeText:
    '為鼓勵香港以至國際年輕人關注全球氣候環境議題、思考全球和國家的沙漠治理及可持續發展，第二屆“庫布其獎“：國際沙漠可持續發展大賽將面向全港大學及大專生，讓學生開拓思路，展現對國際前沿技術的認知及可持續方案的構想，提出創新且可行的沙漠可持續發展方案，以推動解決當前土地荒漠化問題，回應全球碳中和政策目標。',

  // --中學組
  MStopicListText: '學生需製作一條環境永續宣傳短片，內容須包含其中一項主題：',
  MStopicitem1: '能源與氣候變化',
  MStopicitem2: '空氣污染與空氣品質',
  MStopicitem3: '水資源與保護',
  MStopicitem4: '生物多樣性與自然保護',
  // --大專組及大學組
  JCtopicListText: '參賽計劃書可根據一下四個主題其中一個：',
  JCtopicitem1: '沙漠零碳新城設計計劃書',
  JCtopicitem1Info:
    '如何利用現代化科技手段和先進的建築設計理念，實現沙漠都市節能減排、沙漠資源高效利用，同時創造人性化、健康、舒適的居住環境，提升都市生態價值和人居質量？',
  JCtopicitem2: '沙漠生態旅遊商業計劃書',
  JCtopicitem2Info:
    '如何利用沙漠資源和文化為遊客提供沙漠地區獨特的旅遊體驗，同時保護沙漠生態環境和提升當地社區的經濟發展，振興沙漠旅遊業？',
  JCtopicitem3: '沙漠能源及水資源可持續利用計劃書',
  JCtopicitem3Info:
    '如何利用太陽能和風能等可再生能源，以及如何收集、存儲和利用雨水和地下水等水資源，以提高沙漠地區的生產力和經濟發展？',
  JCtopicitem4: '沙漠生態系統保護和恢復計劃書',
  JCtopicitem4Info:
    '如何保護生態脆弱的沙漠中的植被和野生動物，建立沙漠保護區和恢復生態系統的項目，以及推廣永續的土地管理和農業實踐等？',

  // 大賽模式
  // 中學
  JCcontestModeitem1: '比賽地點',
  JCcontestModeitemInfo: '香港（線上）',
  JCcontestModeitem2: '參賽對象',
  JCcontestModeitem2Info: '香港在讀中學生',
  JCcontestModeitem3: '組隊形式',
  //  "2-4人一組，可自行組隊參賽，成員可來自不同學校、不同年級",
  JCcontestModeitem3Info: `<p>可校內自行組隊，每隊由2-4名成員組成</p><p>每隊需由一位學校老師提名，每所學校可多於一隊參賽</p>`,
  JCcontestModeitem4: '作品形式',
  JCcontestModeitem4Info: '1.5分鐘影片；以MP4格式上傳',
  JCcontestModeitem5: '作品語言',
  JCcontestModeitem5Info:
    '參賽者上傳初賽作品後，將由評審進行線上評審。 決賽入圍作品中的15個隊伍將被上傳至大賽官網，並接受公眾點贊。 最終總分將由評審團評分和公眾評分的總和確定。',
  JCcontestModeitem6: '比賽形式',
  JCcontestModeitem6Info:
    '參賽者提交短片後，由評審團評分及選出15份決賽作品，加上公眾投票得出最終結果。',

  // 大專
  JCcontestModeitem1: '比賽地點',
  JCcontestModeitem1Info: '香港（線上及線下）',
  JCcontestModeitem2: '參賽對象',
  JCcontestModeitem21Info:
    '香港所有大學及大專在讀生（包括資助大學、自資院校、專上學院、私立大學等）',
  JCcontestModeitem31: '組隊形式',
  JCcontestModeitem31Info: `可自行組隊參賽，每隊為2-4名成員，成員可來自不同院校、學段及學系`,
  JCcontestModeitem41: '作品形式',
  JCcontestModeitem41Info: '計劃書，以pdf格式提交',
  JCcontestModeitem5: '作品語言',
  // JCcontestModeitem5: "比賽形式",
  JCcontestModeitem5Info: '粵語、英語、國語',
  JCcontestModeitem61: '作品規格',
  // JCcontestModeitem6: "參賽數目上限",
  JCcontestModeitem61Info: `<p>初賽作品：2頁起，包含文字/設計圖/表格；有效表達計劃概念；</p><p>決賽作品：大概5頁，包含完整落實計劃書、財政測算、設計（可選）</p>`,
  JCcontestModeitem7: '比賽形式',
  JCcontestModeitem7Info: `<p>參賽者上載初賽作品後，評審將進行線上評審，並選出決賽隊伍；</p><p>入圍決賽的隊伍將接受專家培訓，並修改、細化作品；
</p><p>提交最終作品後，隊伍將參加線下作品展示及答辯，評審團將現場評分；</p><p>優勝隊伍將於頒獎典禮前公佈。 </p>`,
  // "參賽者上載初賽作品後，評審將進行線上評審。 決賽入圍隊伍有機會修改作品，並參加線下展示及答辯。 評審團將現場評分，選出優勝隊伍。"
  // JCcontestModeitem8: "參賽名額",
  JCcontestModeitem8: '參賽數目上限',
  JCcontestModeitem8Info: '不限',
  // JCcontestModeitem8Info: `<p>參賽者上載初賽作品後，評審將進行線上評審，並選出決賽隊伍；</p><p>入圍決賽的隊伍將接受專家培訓，並修改、細化作品；
  // </p><p>提交最終作品後，隊伍將參加線下作品展示及答辯，評審團將現場評分；</p><p>優勝隊伍將於頒獎典禮前公佈。 </p>`,
  JCcontestModeitem9: '字數限制',
  JCcontestModeitem9Info: '中文3000字內；英文3500字內',

  // 大學國際組
  UcontestModeitem1: '比賽地點',
  judgeDay: '評審日',
  judgeDayInfo: `
  <p>-地點：香港中環紅棉路8號東昌大廈</p>
  <p>-日期：2024年4月11日</p>
  <p>-時間：TBC</p>`,
  UcontestModeitem1Info: '全球（線上）',
  UcontestModeitem2: '參賽對象',
  UcontestModeitem2Info: '全球所有大學就讀全日制大學生及研究生',
  UcontestModeitem3: '組隊形式',
  UcontestModeitem3Info:
    '可自行組隊參賽，每隊為2-4名成員，成員可來自不同院校、學段及學系',
  UcontestModeitem4: '作品形式',
  UcontestModeitem4Info: '計劃書，以pdf格式提交',
  UcontestModeitem5: '參賽名額',
  UcontestModeitem5Info: '粵語、英語、國語',
  UcontestModeitem6: '作品規格',
  UcontestModeitem6Info: `
  <p>初賽作品：2頁起，包含文字/設計圖/表格；有效表達計劃概念；</p>
  <p>決賽作品：參賽隊伍需遞交商業計劃書及滙報用簡報（於評審日滙報中使用）</p>
  <p>1. 商業計劃書：</p>
  <p>&emsp;-格式要求：PDF檔案，需包括完整商業計劃、財務測算、技術設計（可選）頁數不限</p>
  <p>&emsp;-字數限制：中文不少於2,000字，英文不少於2,500字</p>
  <p>&emsp;-最後遞交日期：2024年4月2日 23:59</p>
  <p>&emsp;-商業計劃書一但遞交則不可以更改；如沒有準時遞交簡報的隊伍將被取消比賽資格</p>
  <p>2. 滙報簡報：</p>
  <p>&emsp;-格式要求：PPT檔案，不少於5頁</p>
  <p>&emsp;-最後遞交日期：2024年4月7日 23:59</p>
  <p>&emsp;-簡報一但遞交則不可以更改；如沒有準時遞交簡報的隊伍將被取消比賽資格</p>
  <p>&emsp;-評審日當天主辦方會將隊伍遞交的簡報準備在滙報螢幕上，同時隊伍亦請自行準備備用簡報以備不時之需</p>`,
  UcontestModeitem7Info: `
  <p>參賽者上載初賽作品後，評審將進行線上評審，並選出決賽隊伍；</p>
  <p>入圍決賽的隊伍將接受專家培訓，並修改、細化作品；</p>
  <p>提交最終作品後，隊伍將參加線上作品展示及答辯，評審團將現場評分；</p>
  <p>優勝隊伍將於頒獎典禮前公佈；</p>
  <p>隊伍需在滙報時間前10分鐘到達會場報到，如滙報前10分鐘不夠半數隊員到達會場報到，隊伍將被取消資格；</p>
  <p>滙報時間15分鐘；</p>
  <p>滙報後進行問答環節，由評審向隊伍發問問題，限時5分鐘；</p>
  <p>決賽結果會在4月20日公佈；</p>
  `,
  judgCriteria: '评审标准',
  judgCriteriaInfo: `
  <p>滿分100分，商業計劃書佔總評分的75%，現場滙報評分佔比25%。</p>
  <p>1.商業計劃書（75%）：環境保護性（25%）、創新及原創性（25%）、效益及可行性（25%）</p>
  <p>2.評審日滙報（25%）：以演講者現場滙報表現評分，包括滙報技巧（5%）、PPT展示效果（5%）、問答環節應答表現（5%）、隊員出席率（5%）、滙報用時情況（5%）</p>
  <p>評審員會對所有决賽隊伍根據上述標準進行評分，分數最高的三隊將成為比賽的冠亞季軍。</p>`,
  UcontestModeitem8Info: `限500組（依報名次序進行登記）`,

  // 往屆參賽列表
  talkAboutDesertificationShortFilmCompetition: '「說說荒漠化」短片比賽',
  publicToLikeAwards: '公眾至Like大獎',
  desertGovernanceEntrepreneurshipCompetition: '荒漠治理創業大賽',
  christianAndMissionaryAllianceSunKeiSecondarySchool: '基督教宣道會宣基中學',
  surprisinglyDesolate: '驚「荒」',
  CCCFongYunWahSecondarySchool: '中華基督教會方潤華中學',
  TheMindOftheSandElf: '沙精靈的心事',
  MingChiCollegeOftheChineseChristianChurch: '中華基督教會銘基書院',
  unbalance: '失衡',
  HumanitySinicization: '人類與荒漢化',
  CheungChukShanCollege: '張祝珊英文中學',
  LEGOCityDesolationAndLocalization: '樂高城市荒漢化',
  DesolateLandAndFragrantLand: '荒洲.芳洲',
  MissionaryAssociationChenZhuSuhuaMemorialHighSchool: '宣道會陳朱素華紀念中學',
  Youthtroubles: '少年的煩惱',
  DiocesanGirlsSchool: '拔萃女書院',
  WildernessHair: '荒· 髮',
  ELCHKLutheranSecondarySchool: '基督教香港信義會信義中學',
  DesertificationIssues: '荒漠化問題',
  HongKongRedSwastikaSocietyTaiPoSwastikaSecondarySchool:
    '香港紅卍字會大埔卍慈中學',
  TwoMinutesToUnderstandTheChineseCultureOfTheWilderness: '兩分鐘瞭解荒漢化',
  HongKongFabricManufacturersAssociationZhuShilinSecondarySchool:
    '香港布廠商會朱石麟中學',
  HowSeriousIsDesertification: '荒漠化有多嚴重?',
  LaSalleCollege: '喇沙書院',
  DesertEncyclopedia: '荒漠小百科',
  champion: '冠軍',
  TopTwentyFinalists: '20 強入圍',
  otherWorks: '其他作品',
  MunsangCollegeHongKongIsland: '港島民生書院',
  TheCulpritOfDesertification: '荒漠化元兇',
  PoLeungKukRocheFoundationMiddleSchool: '保良局羅氏基金中學',
  WhenTheEarthEncountersDesertification: '當地球遇上荒漠化',
  EpiscopalLamChoMouSecondarySchool: '聖公會林裘謀中學',
  GlobalWildernessGettoKnowIt: '全球荒漢化·帶你認識它',
  EpiscopalWhiteJohnChurchHighSchool: '聖公會白約翰會督中學',
  EarthPartyTalkingAboutWasteCake: '地球派對- 說荒蛋糕',
  runnerUp: '亞軍',
  TrueLightGirlsCollege: '真光女書院',
  DoNotWasteZhang: '請勿「荒」張',
  TungWahGroupOfHospitalsKapYanDirectorsCollege: '東華三院甲寅年總理中學',
  CryingEarth: '哭不出的地球',
  TungWahGroupOfHospitalsQiuZitianMemorialMiddleSchool:
    '東華三院邱子田紀念中學',
  TheStrangeSoldierOfWildernessAndBirthday: '「荒· 誕」奇兵',
  ThirdPlaceRunnerUp: '季軍',
  EnpingChamberofCommerceandIndustryLiLinmingMiddleSchool:
    '恩平工商會李琳明中學',
  EsportsSandPreventionStrategy: '電競防沙攻略',
  ActivelyParticipatingInSchoolAwards: '最踴躍參與學校大獎',
  CONSTRUCTINGOUTDESERTOPIAKUBUQI:
    'CONSTRUCTING OUR DESERTOPIA | KUBUQI 聯彼朔方',
  HongKongUniversityOfScienceAndTechnology: '香港科技大學',
  UtilizinggeneticallyengineeredmicrobialcocktailstotackledesertificationintheKubuqidesert:
    '利用基因工程微生物混合物治理庫布其沙漠荒漠化',
  OtherWorks: '其他作品',
  CityUniversityOfHongKong: '香港城市大學',
  IoTKubuqiAnEcommercePlatformBringingTheWorldCloserToKubuqi:
    '物聯庫布齊——一個電商平臺讓世界走近庫布齊',
  HongKongBaptistUniversity: '香港浸會大學',
  TheKubuqiAwardDesertificationControlBusinessPlanCompetition:
    '庫布其獎荒漠化治理商業計畫競賽',
  Universities: '香港教育大學、香港中文大學、香港城市大學、香港大學',
  TheArtCapitalofKubuqi: '庫布其藝術之都',
  TheChineseUniversityofHongKong: '香港中文大學',
  KubuqiEnvironmentalProtectionTown: '庫布其環保市鎮',
  CityUniversities: '香港城市大學、香港中文大學、香港大學',
  TheKubuqiAwardDesertificationControlBusinessPlan:
    '庫布其獎-荒漠化控製商業計劃',
  TheUniversityofHongKong: '香港大學',
  MemoryForest: '回憶森林 Memory Forest',
  LingnanSchoolinHongKong: '香港嶺南⼤學',
  DesertificationDesertControlLaw: '荒漠化-荒漠治理⽅法',
  UniversitiesThree: '香港中文大學、香港大學、香港科技大學',
  KubuqiDesertControlBusinessPlanAquaponics:
    '庫布其荒漠治理商業計劃書- 魚菜共生',
  KubuqiDesertProvidingYouWithAnInternationalAcademicExchangePlatformforEcologicalEnvironment:
    '庫布其沙漠—— —提供你一個生態環境的國際學術交流平臺',
  UniversitiesFour: '香港中文大學、香港大學',
  EcoSenseTianyouHeyi: ' EcoSense天遊合一',
  schoolInfoOne: '香港大學、香港理工大學、香港高等教育科技學院',
  schoolInfoTwo: '香港大學、香港浸會大學',
  workName1: '駱也融融',

  // 首頁-大賽時間表
  MiddleSchoolGroupCompetitionProcess: '中學組競賽流程',
  UniversityGroupCompetitionProcess: '大學組比賽流程',

  // 上传提示
  uploadTypeTips: '上傳文件只能是 PDF、PPT、MP4 格式！',

  // 第二届库布其 短片投票
  secondTitle: '第二屆庫布其大賽',
  workDetail: '作品詳情',
  vote: '立即投票',
  voted: '已投票',
  share: '分享',
  votingTime: '投票時間：',
  hintTimeError: '請在規定時間投票',
  copyUrl: '複製連結',
  saveQRCode: '存至本地',
  judgesNameOne: '戴沛權教授',
  judgesNameOneP1: '香港中文大學理學院地球與環境科學課程副教授',
  judgesNameOneP2: '香港中文大學理學院地球系統科學課程主任',
  judgesNameOneP3: '香港中文大學大學通識教育部副主任',
  judgesNameOneP4: '香港中文大學環境、能源及可持續發展研究所副所長',
  judgesNameTwo: '羅敏儀博士',
  judgesNameTwoP1: '自然在地創辦人',
  judgesNameThree: '魏遠強先生',
  judgesNameThreeP1: '香港教育城行政總監',
  judgesNameFour: '江培強博士',
  judgesNameFourP1:
    '香港理工大學設計學院多媒體科藝理學碩士副課程主任及助理教授',
  judgesNameFive: '鄭啟明先生',
  judgesNameFiveP1: '前香港電台一台台長',
  judgesNameSix: '盧永強先生',
  judgesNameSixP1: 'LOMATTERS 創作總監',
  judgesNameSixP2: '綠惜地球副主席',
  judgesNameSixP3: '香港設計中心董事',

  // 补充
  copyText: '連結已複製',
  voteSuccess: '投票成功',
  reTryInfo: '已發送驗證碼，請稍後重試',
  votedInfo: '您已經投過票了哦',
  voteText: '票',

  // 大学组10强
  universityTopTitle: '國際沙漠可持續發展大賽10強',
  universityTopText:
    '萬眾期待的國際沙漠可持續發展大賽10強名單出爐🎉！溫馨提醒10強隊伍需完成包括導師日、導師二次線上指導、提交最終作品及出席最終評審日的現場評審，以保留資格。大賽籌委有權保留最終決定權，包括隨時更改或取消參賽隊伍資格。感謝所有參賽隊伍的參與，帶來精彩的作品，令比賽生色不少💚！ 另外恭喜10強隊伍🥳，稍後將會公佈專家培訓計劃🧑🏻‍💻，大家記得持續關注@thekubuqiaward，取得更多比賽資訊💪🏻！',
  finalistsTitle: '10強名單（排名不分先後）︰',
  talks:
    '#庫布其獎 #ESG #可持續發展 #環保 #社會 #企業 #投資 #香港 #沙漠 #庫布其沙漠 #大專院校 #大學 #中學 #學生 #比賽',

  //
  placeholder1: '請輸入作品名稱',
  placeholder2: '請選擇報名主題',
  notice: '*注意：上傳附件類型為：影片、PDF、PPT；檔案大小不超過2G',
  notice1: '點選上傳作品附件',

  registrationTopic: '報名主題',
  uploaWork: '上傳作品附件',
  theme1: '沙漠零碳新城設計計劃書',
  theme2: '沙漠生態旅遊商業計劃書',
  theme3: '沙漠能源及水資源可持續利用計劃書',
  theme4: '沙漠生態系統保護和恢復計劃書',

  // 第一届比赛花絮
  AwardWinnersList: '中學組獲獎名單',
  workList: '第一屆庫布其大賽-得獎作品',
  collegeContest: '大學生 - 沙漠化治理創業競賽',
  middleContest: '中學生 - 「說說荒漠化」短片比賽',
  workPriceList: '「談談可持續」中學生短片比赛得獎名單',
  workPriceList1: '國際沙漠可持續發展大賽得獎名單',
  side1: '大賽簡介',
  side2: '师友计划',
  side3: '颁奖典礼',
  side4: '库布其沙漠之旅',
  side5: '赛后聚会',
  side6: '作品集',
  side7: '更多照片',

  brief1:
    '三場簡介會於大賽截止報名前舉行，同學們踴躍參與，現場氣氛熱烈。宣講會有幸邀請港龍航空行政總裁丘應樺先生以及億利公益基金董事葉廣濤先生，分別向同學分享撰寫計畫書的要訣以及解答同學對比賽的疑問。',
  brief2:
    ' 經過初賽的激烈競爭，14支優秀隊伍成功晉級至決賽階段，更獲得金融行業專家親身指導的難得機會。</br><div>大賽主辦方特邀巴克萊銀行 (Barclays Bank PLC.)專家擔任學生們的導師，針對商業計劃書中的財務預算部分提供專業意見和建議。專家導師的協助明顯地提升了所有參賽提案的質量和內容的充實程度。</div>',
  brief3:
    '首屆庫布其大獎頒獎典禮由前教育局副局長蔡若蓮博士擔任主禮嘉賓。中聯辦教育科技部前部長李魯及中聯辦教育科技部部長蔣建湘更蒞臨，親身鼓勵年輕一代在科學和環境領域不斷努力探索，為地區以致全球環境保護做出積極貢獻。',
  brief4:
    '獲勝隊伍赴庫布其沙漠實地考察。 </br>- 參觀庫布其生態能源光伏項目 </br> - 參觀高科技種子銀行和種苗溫室</br> -考察億利東方學校</br> - 到牧民家裡體驗當地美食和民俗文化 </br>- 觀看微創氣流法植樹和無人機植樹演示</br> - 親手種下樹苗',
  brief5:
    '大賽圓滿結束後，學生們化敵為友，應邀參加了主辦方組織的賽後聚餐。他們在聚餐中互相交談，分享比賽心得，並提供對下一屆比賽有益的建議。同時，他們亦承諾願意隨時透過分享他們在大賽中所學到的寶貴經驗和知識，為未來的師弟妹們提供幫助和支持。這種薪火相傳氛圍使得大賽的意義更加深遠。不但能夠讓學生們不僅在專業上有所成長，同時亦培養了團隊精神和友誼。',
  timeline: [
    {
      title: '2023/08/15—2023/10/31',
      content: '線上比賽報名'
    },
    {
      title: '2023/08/15—2023/11/05',
      content: '資格審查'
    },
    {
      title: '2023/11/01—2023/12/01',
      content: '提交影片作品'
    },
    {
      title: '2023/11/05—2023/12/05',
      content: '作品首階段篩選'
    },
    {
      title: '2023/12/05—2024/02/01',
      content: '評審評分'
    },
    {
      title: '2024/02/01',
      content: '公佈決賽前15名'
    },
    {
      title: '2024/02/01—2024/03/01',
      content: '民眾投票'
    },
    {
      title: '2024/04/01',
      content: '公佈得獎者'
    },
    {
      title: '待定',
      content: '頒獎典禮'
    },
    {
      title: '六月下旬',
      content: '庫布其考察'
    }
  ],
  UniversityTimeline: [
    { time: '2023/10/03-2023/10/13', name: '大學宣講會' },
    { time: '2023/08/15-TBC', name: '比賽网上申請' },
    { time: '2023/08/15-TBC', name: '資格檢查' },
    { time: '2023/11/20-2023/12/31', name: '初賽作品提交' },
    { time: '2023/11/20-2024/01/05', name: '首階段篩選' },
    { time: '2024/01/05-2024/02/08', name: '評審評分' },
    { time: '2024/02/09', name: '公告10 名決赛入圍者' },
    { time: '2024/02/20-2024/03/28', name: '專家培訓' },
    { time: '2024/04/02', name: '最終作品提交' },
    { time: '2024/04/06-2024/04/13', name: '大學組評審日' },
    { time: '2024/04/20', name: '公佈得奬者' },
    { time: '待定', name: '頒獎典禮' },
    { time: '六月下旬', name: '庫布其考察' }
  ],
  judgesMiddlleSchoolContent: '中學組評委',
  judgesUniversityContent: '大學組評委委',
  judgesDetailText: '詳情',

  winnerTitle1: '地球護衛隊Earth Guardians',
  winnerMenber1: '隊員：邱紫菁、陳艾青、王舒曼、劉美儀',
  winnerSchool1: '學校：風采中學',

  winnerTitle2: '碳世界',
  winnerMenber2: '隊員：羅銳濱、熊文怡、馬欣琳、楊琇巧',
  winnerSchool2: '學校：中華基督教會基元中學',

  winnerTitle3: 'TOAD Sustainable',
  winnerMenber3: '隊員：羅慧婷、蔡灝宏、Sahin Daphne Eylul、粱雅怡',
  winnerSchool3: '學校：林大輝中學',
  workWinnerText1: '冠軍作品：《能源及氣候異常》',
  workWinnerText2: '亞軍作品：《The Earth is so Sick》',
  workWinnerText:
    '季軍作品 ：《為何地球水資源一再受污染？人類到底要如何生存！？地球護衛隊多次強烈聲明：水！請保護！》',

  outstandingText: '優異',

  universityTitle1: '沙漠王子',
  universityMenber1: '隊員：杨茜、王艺桦',
  universityTitle2: '庫布「奇」遊',
  universityMenber2: '隊員：何希琳、楊曉鈴、何浩璋',
  universityTitle3: 'Stan',
  universityMenber3: '隊員：廖若鹏、翁明明、陈靖岚、譚柏立',

  pastGamesTitle1: '《利用基因工程微生物混合物治理庫布其沙漠荒漠化》',
  pastGamesMenber1: '隊員：Keira Lee Rice、Agnieszka Monika Lesniak',
  pastGamesSchool1: '學校：香港科技大學',
  pastGamesTitle2: '《聯彼朔方》',
  pastGamesMenber2: '隊員：翁梓賢、袁映晴、李嘉敏、張曉婷',
  pastGamesSchool2: '學校：香港大學、香港理工大學、香港高等教育科技學院',
  pastGamesTitle3: '《駱也融融》',
  pastGamesMenber3: '队员：周晞晴、黃灝森、史勝義、薛煦祺',
  pastGamesSchool3: '学校：香港大學、香港浸會大學',

  pastGamesWorkTitle1: '冠軍作品：《荒漠化元兇》',
  pastGamesWorkSchool1: '學校：港島民生書院',
  pastGamesWorkMenber1: '隊員：洪嘉軒、林敬賢、蘇鏡濤、葉家寶',
  pastGamesWorkTitle2: '亞軍作品：《請勿「荒」張》',
  pastGamesWorkSchool2: '學校：真光女書院',
  pastGamesWorkMenber2: '隊員：張穎嵐、張旭悅、黃九双、梁嘉慧',
  pastGamesWorkTitle3: '季軍作品 ：《電競防沙攻略》',
  pastGamesWorkSchool3: '學校：恩平工商會李琳明中學',
  pastGamesWorkMenber3: '隊員：莫俊宏、李浩賢',
  pastGamesWorkTitle4: '公眾至Like大獎作品：《荒》',
  pastGamesWorkSchool4: '學校：基督教宣道會宣基中學',
  pastGamesWorkMenber4: '隊員：蔣卓姿、蕭羨憧、楊萃心、王胤稀',

  timeLineTest: '時間軸',
  okText: '確認',

  interestingSidelightsTitle: '庫布其大賽花絮',
  periodTitle: '第二屆',
  interestingSidelightsContent:
    '首屆庫布其大獎頒獎典禮由前教育局副局長蔡若蓮博士擔任主禮嘉賓。中聯辦教育科技部前部長李魯及中聯辦教育科技部部長蔣建湘更蒞臨，親身鼓勵年輕一代在科學和環境領域不斷努力探索，為地區以致全球環境保護做出積極貢獻。',

  interSide1: '大學宣講會',
  interSide2: '導師日',
  interSide3: '終審日',
  interSide4: '頒獎典禮',
  interSide5: '庫布其沙漠之旅',
  interSide6: '得獎作品',
  teachInText: `<span class="text_15"
  >&nbsp;&nbsp;&nbsp;&nbsp;本次大賽走進香港中文大學、香港科技大學、香港教育大學、香港嶺南大學、香港恒生大學、香港城市大學、香港專業教育學院（沙田）及香港理工大學等高校，圍繞氣候變化和生態環境持續惡化等現狀展開系列宣講。主辦方攜手環境科學、可持續發展等領域的專家學者，以跨學科視角剖析全球氣候變暖的嚴峻挑戰與生態惡化的深層影響。嘉賓們立足自身研究，通過前沿數據、區域性案例及創新解決方案，生動闡釋了碳中和路徑、生物多樣性保護、低碳城市建設等議題，並結合香港本土生態政策與學生展開深度對話。</span
>
<p></p>
<span class="text_16"
  >&nbsp;&nbsp;宣講會特設互動環節，鼓勵學生就“個人行動與全球責任”提出見解，現場討論熱烈。活動以多元視角打破思維邊界，不僅深化了青年學子對環境議題的認知，更激發了其投身可持續發展的使命感，為後續環節奠定了扎實的思想基礎。</span
>`,
  side4Text:
    '作為賽程中的核心賦能環節，導師日特邀來自匯豐銀行、數碼港及港鐵公司的資深行業導師組成專家團隊，為十支決賽隊伍提供一對一指導。導師們基於金融創新、智慧科技與可持續發展等多元領域經驗，圍繞專案可行性分析、商業模式優化、技術應用落地及社會影響力拓展等維度，為參賽作品注入行業洞見。通過案例拆解、模擬路演及分組研討，參賽隊伍在數據支撐、邏輯嚴謹性及方案呈現上實現突破性提升，部分作品更融入跨領域資源聯動的新思路，助力學生團隊突破創意與落地的“最後一公里”，為決賽角逐奠定扎實基礎。',
  side5Text:
    '    歷經八個月從創意萌芽、作品迭代到精益打磨的淬煉，十支決賽隊伍在終審日迎來“厚積薄發”的巔峰時刻。終審日現場，團隊以兼具專業深度與敘事張力的路演，展現方案的多元探索，每份作品皆凝聚著香港青年對環境保護與可持續發展的實踐思考。由學界教授、產業領袖及投資人士組成的評審團全程專注，在問答環節與選手展開“火花四濺”的思辨交鋒——針對技術瓶頸的破局策略、商業與社會價值的平衡邏輯等議題，評委以犀利提問激發團隊更縝密的推演，而選手則以數據化論證與跨界思維回應挑戰，讓“理論落地”的路徑愈發清晰。香港環境保護署署長徐浩光博士，JP. 作為特邀嘉賓親臨現場，與學生們親切交流，並傅授重要的指導意見。',
  side6Text:
    '   作為活動的榮耀收官之章，頒獎典禮特邀多位業內專家為這場青年環保創新盛會賦予權威見證與深切期許。親身鼓勵年輕一代在科學和環境領域不斷努力探索，為地區以致全球環境保護做出積極貢獻。',
  side7Text:
    ' 第二屆「庫布其獎」優勝團隊在香港億利公益基金會組織下，走進內蒙古庫布其沙漠，開啟四天三晚的沙漠實地考察。學生們實地探訪陽光穀光氫低碳產業基地，學習光伏治沙與生態修復的前沿技術；走進沙旱生灌木種質中心，見證科技如何讓荒漠煥發生機；在七星湖牧民新村與當地居民互動，感受“治沙致富”的可持續模式。通過親手紮草方格固沙、與沙漠學子交流、體驗綠色農牧生活，香港青少年深刻理解了生態治理的艱辛與智慧。這場沉浸式研學以“一帶一路”綠色發展視角，將低碳理念化為行動信念，讓庫布其的綠色種子在年輕心中生根發芽。',
  workTitle2: '第二屆庫布其大賽-得獎作品',
  photograph: '照片',
  photoWall:'照片墙',
  sustainableMentext:'中學生-「談談可持續」中學生短片比赛',
  sustainableMentext2:'大學生-國際沙漠可持續發展大賽',
}
